/* tslint:disable */
/* eslint-disable */
/**
 * Gentrace API
 * These API routes are designed to ingest events from clients.
 *
 * The version of the OpenAPI document: 0.17.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from "../common";
// @ts-ignore
import { BASE_PATH, BaseAPI, } from "../base";
/**
 * CoreApi - axios parameter creator
 * @export
 */
export const CoreApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Upload an image file
         * @param {string} [org] (If not using an organization API Key) the ID of the organization
         * @param {File} [file] The file to upload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesUploadPost: (org, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/files/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration &&
                configuration.formDataCtor) ||
                FormData)();
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (org !== undefined) {
                localVarQueryParameter["org"] = org;
            }
            if (file !== undefined) {
                localVarFormParams.append("file", file);
            }
            localVarHeaderParameter["Content-Type"] = "multipart/form-data";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get pipelines, optionally filtered by label
         * @param {string} [label] The label to filter pipelines by
         * @param {string} [slug] The slug to filter pipelines by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pipelinesGet: (label, slug, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/pipelines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (label !== undefined) {
                localVarQueryParameter["label"] = label;
            }
            if (slug !== undefined) {
                localVarQueryParameter["slug"] = slug;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a run
         * @param {RunRequest} runRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runPost: (runRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'runRequest' is not null or undefined
            assertParamExists("runPost", "runRequest", runRequest);
            const localVarPath = `/run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(runRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get test cases for a pipeline
         * @param {string} [pipelineId] The ID of the Pipeline to retrieve test cases for
         * @param {string} [pipelineSlug] The slug of the Pipeline to retrieve test cases for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCaseGet: (pipelineId, pipelineSlug, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/test-case`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (pipelineId !== undefined) {
                localVarQueryParameter["pipelineId"] = pipelineId;
            }
            if (pipelineSlug !== undefined) {
                localVarQueryParameter["pipelineSlug"] = pipelineSlug;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an existing test case
         * @param {UpdateTestCase} updateTestCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCasePatch: (updateTestCase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updateTestCase' is not null or undefined
            assertParamExists("testCasePatch", "updateTestCase", updateTestCase);
            const localVarPath = `/test-case`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PATCH" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateTestCase, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a new test case
         * @param {TestCasePostRequest} testCasePostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCasePost: (testCasePostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'testCasePostRequest' is not null or undefined
            assertParamExists("testCasePost", "testCasePostRequest", testCasePostRequest);
            const localVarPath = `/test-case`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(testCasePostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get test results for a pipeline
         * @param {string} pipelineSlug The slug of the pipeline
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultGet: (pipelineSlug, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pipelineSlug' is not null or undefined
            assertParamExists("testResultGet", "pipelineSlug", pipelineSlug);
            const localVarPath = `/test-result`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (pipelineSlug !== undefined) {
                localVarQueryParameter["pipelineSlug"] = pipelineSlug;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Fetch test result by ID
         * @param {string} id The ID of the test result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("testResultIdGet", "id", id);
            const localVarPath = `/test-result/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a new test result from runs
         * @param {TestResultPostRequest} testResultPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultPost: (testResultPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'testResultPostRequest' is not null or undefined
            assertParamExists("testResultPost", "testResultPostRequest", testResultPostRequest);
            const localVarPath = `/test-result`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(testResultPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a new test result from test runs
         * @param {TestResultSimplePostRequest} testResultSimplePostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultSimplePost: (testResultSimplePostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'testResultSimplePostRequest' is not null or undefined
            assertParamExists("testResultSimplePost", "testResultSimplePostRequest", testResultSimplePostRequest);
            const localVarPath = `/test-result-simple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(testResultSimplePostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get status of the test result
         * @param {string} id The ID of the test result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultStatusGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("testResultStatusGet", "id", id);
            const localVarPath = `/test-result/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter["id"] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CoreApi - functional programming interface
 * @export
 */
export const CoreApiFp = function (configuration) {
    const localVarAxiosParamCreator = CoreApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Upload an image file
         * @param {string} [org] (If not using an organization API Key) the ID of the organization
         * @param {File} [file] The file to upload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesUploadPost(org, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.filesUploadPost(org, file, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get pipelines, optionally filtered by label
         * @param {string} [label] The label to filter pipelines by
         * @param {string} [slug] The slug to filter pipelines by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pipelinesGet(label, slug, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pipelinesGet(label, slug, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create a run
         * @param {RunRequest} runRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runPost(runRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.runPost(runRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get test cases for a pipeline
         * @param {string} [pipelineId] The ID of the Pipeline to retrieve test cases for
         * @param {string} [pipelineSlug] The slug of the Pipeline to retrieve test cases for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCaseGet(pipelineId, pipelineSlug, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testCaseGet(pipelineId, pipelineSlug, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an existing test case
         * @param {UpdateTestCase} updateTestCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCasePatch(updateTestCase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testCasePatch(updateTestCase, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create a new test case
         * @param {TestCasePostRequest} testCasePostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCasePost(testCasePostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testCasePost(testCasePostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get test results for a pipeline
         * @param {string} pipelineSlug The slug of the pipeline
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultGet(pipelineSlug, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testResultGet(pipelineSlug, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Fetch test result by ID
         * @param {string} id The ID of the test result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testResultIdGet(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create a new test result from runs
         * @param {TestResultPostRequest} testResultPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultPost(testResultPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testResultPost(testResultPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create a new test result from test runs
         * @param {TestResultSimplePostRequest} testResultSimplePostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultSimplePost(testResultSimplePostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testResultSimplePost(testResultSimplePostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get status of the test result
         * @param {string} id The ID of the test result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultStatusGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testResultStatusGet(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CoreApi - factory interface
 * @export
 */
export const CoreApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CoreApiFp(configuration);
    return {
        /**
         *
         * @summary Upload an image file
         * @param {string} [org] (If not using an organization API Key) the ID of the organization
         * @param {File} [file] The file to upload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesUploadPost(org, file, options) {
            return localVarFp
                .filesUploadPost(org, file, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get pipelines, optionally filtered by label
         * @param {string} [label] The label to filter pipelines by
         * @param {string} [slug] The slug to filter pipelines by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pipelinesGet(label, slug, options) {
            return localVarFp
                .pipelinesGet(label, slug, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a run
         * @param {RunRequest} runRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runPost(runRequest, options) {
            return localVarFp
                .runPost(runRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get test cases for a pipeline
         * @param {string} [pipelineId] The ID of the Pipeline to retrieve test cases for
         * @param {string} [pipelineSlug] The slug of the Pipeline to retrieve test cases for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCaseGet(pipelineId, pipelineSlug, options) {
            return localVarFp
                .testCaseGet(pipelineId, pipelineSlug, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing test case
         * @param {UpdateTestCase} updateTestCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCasePatch(updateTestCase, options) {
            return localVarFp
                .testCasePatch(updateTestCase, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new test case
         * @param {TestCasePostRequest} testCasePostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCasePost(testCasePostRequest, options) {
            return localVarFp
                .testCasePost(testCasePostRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get test results for a pipeline
         * @param {string} pipelineSlug The slug of the pipeline
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultGet(pipelineSlug, options) {
            return localVarFp
                .testResultGet(pipelineSlug, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Fetch test result by ID
         * @param {string} id The ID of the test result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultIdGet(id, options) {
            return localVarFp
                .testResultIdGet(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new test result from runs
         * @param {TestResultPostRequest} testResultPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultPost(testResultPostRequest, options) {
            return localVarFp
                .testResultPost(testResultPostRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new test result from test runs
         * @param {TestResultSimplePostRequest} testResultSimplePostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultSimplePost(testResultSimplePostRequest, options) {
            return localVarFp
                .testResultSimplePost(testResultSimplePostRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get status of the test result
         * @param {string} id The ID of the test result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultStatusGet(id, options) {
            return localVarFp
                .testResultStatusGet(id, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * CoreApi - object-oriented interface
 * @export
 * @class CoreApi
 * @extends {BaseAPI}
 */
export class CoreApi extends BaseAPI {
    /**
     *
     * @summary Upload an image file
     * @param {string} [org] (If not using an organization API Key) the ID of the organization
     * @param {File} [file] The file to upload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    filesUploadPost(org, file, options) {
        return CoreApiFp(this.configuration)
            .filesUploadPost(org, file, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get pipelines, optionally filtered by label
     * @param {string} [label] The label to filter pipelines by
     * @param {string} [slug] The slug to filter pipelines by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    pipelinesGet(label, slug, options) {
        return CoreApiFp(this.configuration)
            .pipelinesGet(label, slug, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a run
     * @param {RunRequest} runRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    runPost(runRequest, options) {
        return CoreApiFp(this.configuration)
            .runPost(runRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get test cases for a pipeline
     * @param {string} [pipelineId] The ID of the Pipeline to retrieve test cases for
     * @param {string} [pipelineSlug] The slug of the Pipeline to retrieve test cases for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    testCaseGet(pipelineId, pipelineSlug, options) {
        return CoreApiFp(this.configuration)
            .testCaseGet(pipelineId, pipelineSlug, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing test case
     * @param {UpdateTestCase} updateTestCase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    testCasePatch(updateTestCase, options) {
        return CoreApiFp(this.configuration)
            .testCasePatch(updateTestCase, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new test case
     * @param {TestCasePostRequest} testCasePostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    testCasePost(testCasePostRequest, options) {
        return CoreApiFp(this.configuration)
            .testCasePost(testCasePostRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get test results for a pipeline
     * @param {string} pipelineSlug The slug of the pipeline
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    testResultGet(pipelineSlug, options) {
        return CoreApiFp(this.configuration)
            .testResultGet(pipelineSlug, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Fetch test result by ID
     * @param {string} id The ID of the test result
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    testResultIdGet(id, options) {
        return CoreApiFp(this.configuration)
            .testResultIdGet(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new test result from runs
     * @param {TestResultPostRequest} testResultPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    testResultPost(testResultPostRequest, options) {
        return CoreApiFp(this.configuration)
            .testResultPost(testResultPostRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new test result from test runs
     * @param {TestResultSimplePostRequest} testResultSimplePostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    testResultSimplePost(testResultSimplePostRequest, options) {
        return CoreApiFp(this.configuration)
            .testResultSimplePost(testResultSimplePostRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get status of the test result
     * @param {string} id The ID of the test result
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    testResultStatusGet(id, options) {
        return CoreApiFp(this.configuration)
            .testResultStatusGet(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
